import * as yup from 'yup';

export const NewOrgSchema = yup.object().shape({
    newOrgName: yup
        .string()
        .ensure()
        .required('Org name is required')
});
